type YoutubeApi = typeof YT

let loadPromise: Promise<YoutubeApi> | null = null

declare global {
  interface Window {
    onYouTubeIframeAPIReady?: () => void
  }
}

/** Load the YouTube IFrame API script once. */
export function loadYoutubeApi(): Promise<YoutubeApi> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('YouTube API requires a browser.'))
  }

  if (window.YT && window.YT.Player) {
    return Promise.resolve(window.YT)
  }

  if (loadPromise) return loadPromise

  loadPromise = new Promise((resolve, reject) => {
    const prior = window.onYouTubeIframeAPIReady
    window.onYouTubeIframeAPIReady = () => {
      prior?.()
      if (window.YT) {
        resolve(window.YT)
      } else {
        reject(new Error('YouTube API failed to initialize.'))
      }
    }

    const existing = document.querySelector<HTMLScriptElement>(
      'script[src="https://www.youtube.com/iframe_api"]',
    )
    if (existing) return

    const script = document.createElement('script')
    script.src = 'https://www.youtube.com/iframe_api'
    script.async = true
    script.onerror = () => {
      loadPromise = null
      reject(new Error('Could not load the YouTube player script. Check your connection.'))
    }
    document.head.appendChild(script)
  })

  return loadPromise
}
